document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'galleryReveal', ({ initial = 6, step = 3 } = {}) => ({
		initial,
		step,
		visible: initial,

		init() {
			this.visible = this.initial;
		},

		// Whether the card at the given index should be shown.
		show( index ) {
			return index < this.visible;
		},

		// Whether more cards remain to reveal.
		hasMore() {
			return this.visible < this.$refs.grid.children.length;
		},

		// Reveal the next batch of cards.
		more() {
			this.visible += this.step;
		},
	}) );
});
